import React, { FunctionComponent } from "react";
import { Result } from "antd";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../Button";

const NotFound: FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <Result
      status="404"
      title="404"
      subTitle={t("not_found_message")}
      extra={
        <Button
          size="large"
          onClick={() => history.push("/home")}
          className="table"
          type="primary"
        >
          {t("back_to_home")}
        </Button>
      }
    />
  );
};
export default NotFound;
